import { render, staticRenderFns } from "./ImprovementReport.vue?vue&type=template&id=0232640d"
import script from "./ImprovementReport.vue?vue&type=script&lang=js"
export * from "./ImprovementReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports